import { applyMiddleware, compose, createStore } from 'redux'
import reducer from './reducers'
import thunkMiddleware from 'redux-thunk'
import { load, save } from 'redux-localstorage-simple'

const localStorageSettings = {
  states: ['cart', 'adminUser', 'checkout', 'salesToken'],
  namespace: 'mgds_v2',
  namespaceSeparator: '::'
}
const preloadedState = load(localStorageSettings)
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(reducer, preloadedState, composeEnhancers(
  applyMiddleware(thunkMiddleware),
  applyMiddleware(save(Object.assign({ debounce: 200, }, localStorageSettings)))
  )
)
export default store
